import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Mensagens } from 'src/app/view/shared/components/mensagens-ptbr';
import { MsgService } from './msg.service';

@Injectable({
  providedIn: 'root'
})
export class HandleErrosService {

  constructor(private msgService: MsgService) { }

  handleError(error: HttpErrorResponse) {
    this.msgService.getMessage('error', error.error.error.msg.summary, error.error.error.msg.detail);
    return throwError(error);
  }

  handleErrorLogin(error: HttpErrorResponse) {
    this.msgService.getMessage('warn', error.error.error.msg.summary, error.error.error.msg.detail);
    return throwError(error);
  }

  //função que captura erro com status 500
  check500Error(error) {
    switch (error.status) {
      case 500:
        this.msgService.getMessage('error', error.error.error.msg.summary, error.error.error.msg.detail);
        break;
    }
  }
  handleErrorInactivate(error: HttpErrorResponse) {
    this.msgService.getMessage(
      "warn",
      Mensagens.ConsultaErroSummary,
      Mensagens.ConsultaInativadaDetail
    );
    return throwError(() => error);
  }

  handleErrorSearch(error: HttpErrorResponse) {
    this.msgService.getMessage(
      "warn",
      Mensagens.ConsultaErroSummary,
      Mensagens.ConsultaErroDetail
    );
    return throwError(() => error);
  }

}
